/**
 * Given a current sort string and a fieldName, returns the new sort string
 * to use for sorting.
 *
 * @param  {string} currentSortString    - String used for sorting. This could
 *                                         be prefixed with `-` to indicate
 *                                         descending sort (i.e. `-value`)
 * @param  {string} toggledFieldName     - fieldName from JSON schema that
 *                                         was toggled
 * @return {string}                      - New sort string after toggle
 */
export function toggleSort(currentSortString?: string | null, toggledFieldName?: string | null) {
    const sortField = toggledFieldName || 'name';

    return currentSortString === sortField ? `-${sortField}` : sortField;
}
